/** 首页论坛卡默认文案 - 作者: zbq, 日期: 2026-08-30 */

export const DEFAULT_FORUM_TITLE = '福家智库';

export const DEFAULT_FORUM_INTRO =
  '福家智库专注体彩内容与数据分析，专家均经实名考核。竞彩、数字彩等方案可在站内查看；本平台不售彩，购彩请到线下体彩店。';
